import { EMatModal, EMatTabs } from "Components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OPERATION_POSITION, OPERATION_TYPES } from "src/constants/operation";
import Summary from "./Summary/Summary";
import BuyOrSellForm from "./BuyOrSellForm/BuyOrSellForm";
import * as actions from "../../store/actions";
import "./BuyOrSellModal.scss";
import { useAppDispatch } from "src/hooks/reduxHooks";

const BuyOrSellModal = ({
  onCancel,
  onBuy,
  onSell,
  getContainer,
  instrument,
  loading,
  onGetContraPosition,
  contraPositions,
  loadingContrapositions,
  isUpdate,
  optionType,
  opType = OPERATION_TYPES.BUY,
  asociatedAlert,
  setIsSumaryVisible,
  setTons,
  tons,
}: {
  onCancel: () => void;
  onBuy: (values: any) => void;
  onSell: (values: any) => void;
  getContainer?: string | HTMLElement | (() => HTMLElement) | false;
  instrument: any;
  loading: boolean;
  operationSubmitted?: any;
  onGetContraPosition: (operation: string) => void;
  contraPositions?: any[] | undefined | null;
  loadingContrapositions: boolean;
  isUpdate: boolean;
  optionType: string;
  opType?: string;
  asociatedAlert?: number;
  setIsSumaryVisible: (value: boolean) => void;
  setTons: (value: number) => void;
  tons: number | null;
}) => {
  const [t] = useTranslation();
  const dispatch = useAppDispatch();
  const [operationType, setOperationType] = useState(opType);
  const [operationToSubmit, setOperationToSubmit] = useState<any>();
  const [operationToEdit, setOperationToEdit] = useState<any>();

  const handleSubmitSell = (values: any) => {
    const operation = values;
    operation.instrument = instrument._id;
    operation.operation = OPERATION_TYPES.SELL;
    operation.optionType = optionType;

    setOperationToSubmit(operation);
  };

  const handleSubmitBuy = (values: any) => {
    const operation = values;
    operation.instrument = instrument._id;
    operation.operation = OPERATION_TYPES.BUY;
    operation.optionType = optionType;

    setOperationToSubmit(operation);
  };

  const handleConfirmOperation = (values: any) => {
    values.operation === OPERATION_TYPES.BUY ? onBuy(values) : onSell(values);
    if (asociatedAlert) {
      dispatch(actions.deleteAlert({ id: asociatedAlert }));
    }
  };
  const tabs = [
    {
      tab: t("operation:common.buy").toUpperCase(),
      key: OPERATION_TYPES.BUY,
      component: (
        <BuyOrSellForm
          id="buy-form"
          instrument={instrument.instrument_name}
          price={parseFloat(instrument.bid)}
          onCancel={onCancel}
          onSubmit={handleSubmitBuy}
          loading={loading}
          isBuy={true}
          operationToEdit={operationToEdit}
          optionType={optionType}
          tons={tons}
        />
      ),
    },
    {
      tab: t("operation:common.sell").toUpperCase(),
      key: OPERATION_TYPES.SELL,
      component: (
        <BuyOrSellForm
          id="sell-form"
          instrument={instrument.instrument_name}
          price={parseFloat(instrument.offer)}
          onCancel={onCancel}
          onSubmit={handleSubmitSell}
          loading={loading}
          isBuy={false}
          operationToEdit={operationToEdit}
          optionType={optionType}
          tons={tons}
        />
      ),
    },
  ];

  const handleClickTab = (key: string) => {
    setOperationType(key);
  };

  const handleEdit = () => {
    setOperationToEdit(operationToSubmit);
    setOperationToSubmit(null);
  };

  const handleGoToOperate = () => {
    setOperationToSubmit(null);
    setOperationToEdit(null);
    onCancel();
  };

  return (
    <EMatModal
      closable={true}
      visible={true}
      title=""
      className={
        operationToSubmit
          ? operationToSubmit?.position === OPERATION_POSITION.CLOSE
            ? "buy-sell-modal background close"
            : "buy-sell-modal background"
          : "buy-sell-modal"
      }
      onCancel={onCancel}
      footer={null}
      getContainer={getContainer}
    >
      {operationToSubmit ? (
        <Summary
          operation={operationToSubmit}
          onClickConfirm={handleConfirmOperation}
          onGetContraPosition={() => onGetContraPosition(operationType)}
          contraPositions={contraPositions}
          onClickEdit={handleEdit}
          onClickGoToOperate={handleGoToOperate}
          submitting={loading}
          loading={loadingContrapositions}
          optionType={optionType}
          setIsSumaryVisible={setIsSumaryVisible}
        />
      ) : (
        <EMatTabs
          defaultActiveKey={operationToEdit?.operation || opType}
          size="large"
          className="operations-tabs"
          centered
          moreIcon={<div></div>}
          onTabClick={handleClickTab}
          tabs={tabs}
        />
      )}
    </EMatModal>
  );
};

export default BuyOrSellModal;
